module.exports = __webpack_public_path__ + "static/media/Colette Super King 4-Drawer Bed Base 200x210 cm_White.699e3bcf.png";